var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_5310)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1498_5310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7 9.66055L4.14 18.3905C4.05 18.0605 4 17.7105 4 17.3505V8.01055C4 4.93055 7.33 3.01055 10 4.55055L14.04 6.88055L18.09 9.22056C18.31 9.35056 18.52 9.49055 18.7 9.66055Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0887 16.1405L14.0387 18.4805L9.99875 20.8105C8.08875 21.9105 5.83875 21.2505 4.71875 19.6405L5.13875 19.3905L19.5787 10.7305C20.5787 12.5305 20.0887 14.9905 18.0887 16.1405Z",
    fill: "#392C7D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_5310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.679688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1498_5310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.679688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.b677510b8f725691a4e2c786497635ed.svg";
export { ForwardRef as ReactComponent };